import axios from 'axios';

const API = axios.create({
 baseURL: `https://launchpad.inwent.ca/backend/api`,
  // baseURL: `http://127.0.0.1:8000/api`,
});

export const BASE_ASSET_URL = 'https://launchpad.inwent.ca/backend/';
// export const BASE_ASSET_URL = 'http://127.0.0.1:8000';

export const BASE_DEFAULT_IMAGE_URL = 'https://launchpad.inwent.ca/frontend/default-feed-item.jpg';
// export const BASE_DEFAULT_IMAGE_URL = 'http://localhost:3000/default-feed-item.jpg';

export const getloginUserId = () => {
  try {
    const user = JSON.parse(localStorage.getItem("loginUser"));
    return user?.id || null;
  } catch {
    return null;
  }
};

export default API;
